// extracted by mini-css-extract-plugin
export default {"chat-locker":"chat-policy_chat-locker__972mj","locked":"chat-policy_locked__75wHp"};